import type { IntlShape } from 'react-intl';

import { IconType } from '~/eds/src/types/IconType';

import { DataFieldType } from '../../enums/DataFieldType';

export const getIconFromFieldType = (type: DataFieldType): IconType => {
  switch (type) {
    case DataFieldType.ARRAY_MULTIPLE:
    case DataFieldType.ARRAY_SINGLE:
      return 'field-dropdown';
    case DataFieldType.ATTACHMENT:
      return 'attachment';
    case DataFieldType.BOOLEAN:
      return 'field-boolean';
    case DataFieldType.CLAUSE:
      return 'field-clause';
    case DataFieldType.DATE:
      return 'field-date';
    case DataFieldType.NUMBER:
      return 'field-number';
    case DataFieldType.STRING:
      return 'field-short-response';
    case DataFieldType.TEXT_AREA:
      return 'field-paragraph';
    default:
      return 'field';
  }
};

export const getFieldTypeIconProps = (
  type: DataFieldType,
  intl: IntlShape,
): { icon: IconType; label: string; tooltip: string } => {
  const label = getFieldTypeLabel(type, intl);
  return {
    icon: getIconFromFieldType(type),
    label,
    tooltip: label,
  };
};

export const getFieldTypeLabel = (
  type: DataFieldType,
  intl: IntlShape,
): string => {
  switch (type) {
    case DataFieldType.ARRAY_MULTIPLE:
      return intl.formatMessage({
        id: 'Utils.dropdownMultipleValues',
        defaultMessage: 'Dropdown (allows multiple values)',
        description:
          'Label for dropdown field type that allows multiple selections',
      });
    case DataFieldType.ARRAY_SINGLE:
      return intl.formatMessage({
        id: 'Utils.dropdownSingleValue',
        defaultMessage: 'Dropdown (allows single value)',
        description:
          'Label for dropdown field type that allows single selection',
      });
    case DataFieldType.ATTACHMENT:
      return intl.formatMessage({
        id: 'Utils.attachment',
        defaultMessage: 'Attachment',
        description: 'Label for attachment field type',
      });
    case DataFieldType.BOOLEAN:
      return intl.formatMessage({
        id: 'Utils.boolean',
        defaultMessage: 'Boolean',
        description: 'Label for boolean field type',
      });
    case DataFieldType.CLAUSE:
      return intl.formatMessage({
        id: 'Utils.clause',
        defaultMessage: 'Clause',
        description: 'Label for clause field type',
      });
    case DataFieldType.DATE:
      return intl.formatMessage({
        id: 'Utils.date',
        defaultMessage: 'Date',
        description: 'Label for date field type',
      });
    case DataFieldType.NUMBER:
      return intl.formatMessage({
        id: 'Utils.number',
        defaultMessage: 'Number',
        description: 'Label for number field type',
      });
    case DataFieldType.STRING:
      return intl.formatMessage({
        id: 'Utils.text',
        defaultMessage: 'Text',
        description: 'Label for text field type',
      });
    case DataFieldType.TEXT_AREA:
      return intl.formatMessage({
        id: 'Utils.textArea',
        defaultMessage: 'Text area',
        description: 'Label for text area field type',
      });
    default:
      return intl.formatMessage({
        id: 'Utils.unknown',
        defaultMessage: 'Unknown',
        description: 'Label for unknown field type',
      });
  }
};
